// src/components/Dashboard/SummaryCard.jsx
import React from "react";
import "../../styles/SummaryCard.css"; // optional: style ringkas

const SummaryCard = ({ data = [] }) => (
    <div className="summary-card">
        {data.map((item, i) => (
            <div key={i}>
                <h4>{item.value}</h4>
                <span>{item.label}</span>
            </div>
        ))}
    </div>
);

export default SummaryCard;
